import BaseModel from '../core/BaseModel'
export default class SettingsModel extends BaseModel {
    constructor() {
        super({ 
                name: "settings",
                tableName: 'core_settings'
            }, 
            {
            id: { 
                name: 'id', 
                type: "String", 
                label: 'ID', 
                primaryKey: true,
                display: false
            },
            key: { 
                name: 'key', 
                type: "String", 
                label: 'Từ khoá',
                filter: { type: 'input', match: 'contains'}
            },
            value : { 
                name: 'value ', 
                type: "String", 
                label: 'Giá trị',
                filter: { type: 'input', match: 'contains'}
            }
        },)
    }

}